<template>

  <div class="panel panel-clinic">

    <div class="panel-heading collapsed" href="#form_education" data-toggle="collapse">

      <div class="arrow-down"></div>

      <h2 class="panel-title">Utbildning & erfarenhet</h2>

    </div>

    <div id="form_education" class="panel-collapse collapse">

      <div class="panel-body">

        <h3>Grundläggande frågor, gäller alla partners</h3>
        <p class="comment subline">Dessa frågor gås igenom vid första "intervjusamtal"</p>

        <div class="form-horizontal">

          <row-text
            :model.sync="clinic.education"
            type="textarea"
            text="Utbildning och erfarenhet, fritext."
            comment="Be partnern att själv kort berätta om sin utbildning och sin erfarenhet. Anteckna i fritextrutan vid behov eller fyll i respektive ruta längre ned.">
          </row-text>

        </div>

        <h3>Utbildning</h3>
        <p class="comment subline">Be partnern upprepa eller förtydliga om du inte hunnit med att fylla i rutorna nedan.
          Ta dem en och en.
          <br>
          Vilken utbildningsnivå har personen som massör eller PT? Normalt sett nämner man sin högsta nivå.
          <br>
          Om man utbildat sig i omgångar kan de olika stegen vara tagna på olika skolor.</p>

        <div class="form-horizontal">

          <div v-if="clinic.product_area_ids.indexOf(1) !== -1">
            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              :showComment="true"
              type="checkbox_diploma_massage"
              layout="checkBox"
              title="Diplomerad massör">
            </row-meta>
            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              type="text_diploma_massage_school"
              layout="textInput"
              title="Vilken skola?">
            </row-meta>
            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              type="text_diploma_massage_graduation"
              layout="textInput"
              title="Examensår">
            </row-meta>

            <br>

            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              :showComment="true"
              type="checkbox_diploma_massage_therapist"
              layout="checkBox"
              title="Diplomerad massageterapeut">
            </row-meta>
            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              type="text_diploma_massage_therapist_school"
              layout="textInput"
              title="Vilken skola?">
            </row-meta>
            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              type="text_diploma_massage_therapist_graduation"
              layout="textInput"
              title="Examensår">
            </row-meta>

            <br>

            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              :showComment="true"
              type="checkbox_diploma_massage_therapist_medical"
              layout="checkBox"
              title="Diplomerad medicinsk massageterapeut">
            </row-meta>
            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              type="text_diploma_massage_therapist_medical_school"
              layout="textInput"
              title="Vilken skola?">
            </row-meta>
            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              type="text_diploma_massage_therapist_medical_graduation"
              layout="textInput"
              title="Examensår">
            </row-meta>

          </div>

          <div v-if="clinic.product_area_ids.indexOf(2) !== -1">
            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              :showComment="true"
              type="checkbox_education_pt"
              layout="checkBox"
              title="PT-utbildning">
            </row-meta>
            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              type="text_education_pt_school"
              layout="textInput"
              title="Vilken skola?">
            </row-meta>
            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              type="text_education_pt_graduation"
              layout="textInput"
              title="Examensår">
            </row-meta>
          </div>

          <br>

          <row-meta
            :clinic-id="clinic.id"
            :row-meta="meta"
            :showComment="true"
            type="checkbox_education_misc"
            layout="checkBox"
            title="Annan utbildning">
          </row-meta>
          <row-meta
            :clinic-id="clinic.id"
            :row-meta="meta"
            type="text_education_misc_description"
            layout="textInput"
            title="Kort beskrivning">
          </row-meta>
          <row-meta
            :clinic-id="clinic.id"
            :row-meta="meta"
            type="text_education_misc_school"
            layout="textInput"
            title="Vilken skola?">
          </row-meta>
          <row-meta
            :clinic-id="clinic.id"
            :row-meta="meta"
            type="text_education_misc_graduation"
            layout="textInput"
            title="Examensår">
          </row-meta>

          <div v-if="clinic.product_area_ids.indexOf(1) !== -1">
            <br>

            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              :showComment="true"
              type="checkbox_certified_bsm"
              layout="checkBox"
              title="Certifierad massör enlig BSM"
              comment="Är massören certifierad enligt BSM (Branschrådet Svensk Massage)?">
            </row-meta>
          </div>

          <div v-if="clinic.product_area_ids.indexOf(2) !== -1">
            <br>

            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              :showComment="true"
              type="checkbox_pt_certified_active_sweden"
              layout="checkBox"
              title="Licensierad via Active sweden">
            </row-meta>

            <row-meta
              :clinic-id="clinic.id"
              :row-meta="meta"
              :showComment="true"
              type="checkbox_pt_certified_international"
              layout="checkBox"
              title="Internationell licens">
            </row-meta>
          </div>

        </div>

        <h3>Erfarenhet & övrigt</h3>

        <div class="form-horizontal">

          <row-meta
            :clinic-id="clinic.id"
            :row-meta="meta"
            type="text_experience_misc"
            layout="textBox"
            title="Erfarenhet"
            comment="Vilken erfarenhet har massören? Dvs i vilken omfattning har hen arbetat med massage sedan utbildningen?">
          </row-meta>
          <row-meta
            :clinic-id="clinic.id"
            :row-meta="meta"
            type="text_current_business"
            layout="textBox"
            title="Nuvarande verksamhet som massör"
            comment="I vilken omfattning arbetar hen med massage idag?">
          </row-meta>
          <row-meta
            :clinic-id="clinic.id"
            :row-meta="meta"
            :showComment="true"
            type="checkbox_own_clinic_join"
            layout="checkBox"
            title="Är intresserad av att ansluta min mottagning"
            comment="Är massören intresserad av samarbete kring mottagning?">
          </row-meta>
          <row-meta
            :clinic-id="clinic.id"
            :row-meta="meta"
            :showComment="true"
            type="checkbox_intrest_in_external"
            layout="checkBox"
            title="Är intresserad av företagsuppdrag"
            comment="Är massören intresserad av samarbete kring företagsuppdrag?">
          </row-meta>
          <row-meta
            :clinic-id="clinic.id"
            :row-meta="meta"
            type="textarea_education_extra_info"
            layout="textBox"
            title="Extra anteckningsruta, grundläggande frågor"
            comment="Något annat du vill anteckna?">
          </row-meta>

        </div>

      </div>

    </div>

  </div>

</template>

<script>

import mixin from './mixin'

export default {

    mixins: [mixin],

    data () {
        return {}
    }

}

</script>
